/*
 * sachet-guide.js — /pages/sachet-guide の計測（HAM-4106）
 *
 * KPI:
 *   guide page view        -> sachet_guide_view
 *   sachet FAQ expand      -> sachet_faq_expand
 *   guide -> product click -> sachet_guide_click（外向きリンクに hh_guide を付与）
 *   （補助）読了            -> sachet_guide_scroll_depth
 *
 * storefront-only best effort。PostHog 未ロード時は何もしない。
 * layout/theme.liquid の {%- unless Shopify.designMode -%} 内から読み込むため
 * テーマエディタでは発火しない。
 */
(function () {
  var SOURCE = 'theme_sachet_guide';
  var SCROLL_MILESTONES = [25, 50, 75, 100];

  function hasPosthog() {
    return !!(window.posthog && typeof window.posthog.capture === 'function');
  }

  function baseProps() {
    var script = document.currentScript;
    return {
      page_handle: (script && script.dataset.pageHandle) || null,
      template_name: (script && script.dataset.templateName) || null,
      instrumentation_source: SOURCE
    };
  }

  var BASE = baseProps();

  function capture(event, props, options) {
    if (!hasPosthog()) return;
    var payload = {};
    var key;
    for (key in BASE) {
      if (Object.prototype.hasOwnProperty.call(BASE, key)) payload[key] = BASE[key];
    }
    for (key in props) {
      if (Object.prototype.hasOwnProperty.call(props, key)) payload[key] = props[key];
    }
    try {
      window.posthog.capture(event, payload, options);
    } catch (e) {
      console.warn('[PostHog] ' + event + ' capture failed:', e);
    }
  }

  function sectionIdOf(node) {
    try {
      var host = node.closest('[id^="shopify-section-"]');
      if (!host) return null;
      // shopify-section-template--20729284362391__cta -> cta
      return host.id.replace('shopify-section-', '').replace(/^template--\d+__/, '');
    } catch (e) {
      return null;
    }
  }

  /* ---- guide page view ------------------------------------------------ */

  function captureView() {
    capture('sachet_guide_view', {});
  }

  /* ---- FAQ expand ------------------------------------------------------ */

  var faqSeen = {};

  function bindFaq() {
    try {
      var rows = document.querySelectorAll('[id^="shopify-section-"] .accordion details');
      Array.prototype.forEach.call(rows, function (details, index) {
        if (details.dataset.sachetFaqBound === '1') return;
        details.dataset.sachetFaqBound = '1';
        details.addEventListener('toggle', function () {
          if (!details.open) return;
          var summary = details.querySelector('summary');
          var question = summary ? (summary.textContent || '').trim().slice(0, 80) : null;
          var key = question || 'faq_' + index;
          // 開閉を繰り返しても 1 ページロードにつき 1 回だけ送る
          if (faqSeen[key]) return;
          faqSeen[key] = true;
          capture('sachet_faq_expand', {
            question: question,
            faq_index: index + 1,
            faq_section_id: sectionIdOf(details)
          });
        });
      });
    } catch (e) {
      console.warn('[PostHog] sachet_faq_expand bind failed:', e);
    }
  }

  /* ---- outbound click -------------------------------------------------- */

  var TARGET_TYPES = [
    { prefix: '/collections', type: 'collection', stamp: true },
    { prefix: '/products', type: 'product', stamp: true },
    { prefix: '/blogs', type: 'blog', stamp: false },
    { prefix: '/pages', type: 'page', stamp: false }
  ];

  function matchTarget(pathname) {
    for (var i = 0; i < TARGET_TYPES.length; i += 1) {
      if (pathname.indexOf(TARGET_TYPES[i].prefix) === 0) return TARGET_TYPES[i];
    }
    return null;
  }

  function stampGuideParams(link, position) {
    var href = link.getAttribute('href');
    if (!href || href.indexOf('hh_guide=') !== -1) return;
    var joiner = href.indexOf('?') === -1 ? '?' : '&';
    var suffix = 'hh_guide=1';
    if (position) suffix += '&hh_guide_from=' + encodeURIComponent(position);
    link.setAttribute('href', href + joiner + suffix);
  }

  function onClick(event) {
    try {
      if (!(event.target instanceof Element)) return;
      var link = event.target.closest('a[href]');
      if (!link) return;
      // 診断セクションは自前で URL を組み立て、独自イベントを送るため対象外
      if (link.closest('[data-hitoyasumi-quiz]')) return;

      var url = new URL(link.href, window.location.origin);
      if (url.origin !== window.location.origin) return;

      var target = matchTarget(url.pathname);
      if (!target) return;

      var position = sectionIdOf(link);
      if (target.stamp) stampGuideParams(link, position);

      capture(
        'sachet_guide_click',
        {
          target_type: target.type,
          link_url: url.pathname,
          link_label: (link.textContent || '').trim().slice(0, 60),
          link_position: position
        },
        { send_instantly: true }
      );
    } catch (e) {
      console.warn('[PostHog] sachet_guide_click capture failed:', e);
    }
  }

  /* ---- scroll depth ---------------------------------------------------- */

  function bindScrollDepth() {
    var fired = {};
    var ticking = false;

    function measure() {
      ticking = false;
      var doc = document.documentElement;
      var scrollable = doc.scrollHeight - window.innerHeight;
      if (scrollable <= 0) return;
      var percent = ((window.scrollY || doc.scrollTop) / scrollable) * 100;
      for (var i = 0; i < SCROLL_MILESTONES.length; i += 1) {
        var milestone = SCROLL_MILESTONES[i];
        if (percent >= milestone && !fired[milestone]) {
          fired[milestone] = true;
          capture('sachet_guide_scroll_depth', { depth_percent: milestone });
          if (milestone === 100) teardown();
        }
      }
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(measure);
    }

    function teardown() {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    measure();
  }

  /* ---- boot ------------------------------------------------------------ */

  function boot() {
    captureView();
    bindFaq();
    bindScrollDepth();
    document.addEventListener('click', onClick);
    // テーマエディタでセクションを差し替えると details が入れ替わるため再バインド
    document.addEventListener('shopify:section:load', bindFaq);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
